import { render, staticRenderFns } from "./SearchArticleList.vue?vue&type=template&id=2e1d5eff&"
import script from "./SearchArticleList.vue?vue&type=script&lang=js&"
export * from "./SearchArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports